export const tagsCategory = {
  lstcomplaints: "Complaints",
  lstobservations: "Observations",
  lstdiagnosis: "Diagnosis",
  lstworkDone: "WorkDone",
  lstadvice: "Advice",
  lstinvestigations: "Investigations",
};

export const typeOptions = [
  { label: "TAB", value: "TAB" },
  { label: "SYP", value: "SYP" },
  { label: "CRM", value: "CRM" },
  { label: "POW", value: "POW" },
  { label: "INJ", value: "INJ" },
  { label: "CAP", value: "CAP" },
  { label: "DRP", value: "DRP" },
  { label: "SUS", value: "SUS" },
  { label: "LIQ", value: "LIQ" },
  { label: "SAC", value: "SAC" },
  { label: "EXP", value: "EXP" },
  { label: "OIN", value: "OIN" },
  { label: "GEN", value: "GEN" },
  { label: "LOT", value: "LOT" },
  { label: "GEL", value: "GEL" },
  { label: "GRA", value: "GRA" },
  { label: "SOAP", value: "SOAP" },
  { label: "SOL", value: "SOL" },
  { label: "VAC", value: "VAC" },
  { label: "PAS", value: "PAS" },
  { label: "INH", value: "INH" },
  { label: "OTH", value: "OTH" },
  { label: "SPR", value: "SPR" },
];

export const unitOptions = [
  { label: "mg", value: "mg" },
  { label: "mcg", value: "mcg" },
  { label: "ml", value: "ml" },
  { label: "IU", value: "IU" },
  { label: "g", value: "g" },
  { label: "ug", value: "ug" },
  { label: "tsp", value: "tsp" },
  { label: "drps", value: "drps" },
  { label: "units", value: "units" },
  { label: "tab", value: "tab" },
  { label: "cap", value: "cap" },
  { label: "puffs", value: "puffs" },
];

export const timingOptions = [
  {
    value: "Beforefood",
    label: "Before Food",
  },
  {
    value: "Afterfood",
    label: "After Food",
  },
  {
    value: "EmptyStomach",
    label: "Empty Stomach",
  },
  {
    value: "BeforeBreakfast",
    label: "Before Breakfast",
  },
  {
    value: "AfterBreakfast",
    label: "After Breakfast",
  },
  {
    value: "SOS",
    label: "SOS",
  },
  {
    value: "BedTime",
    label: "Bed Time",
  },
];
